export default __webpack_public_path__ + "static/media/018-woman.912b94a2.svg";